import * as authStore from '@cartwhl/common/stores/authStore';
import * as navigationStore from '@cartwhl/common/stores/navigationStore';
import * as noticesStore from '@cartwhl/common/stores/noticesStore';
import * as productStore from '@cartwhl/common/stores/productStore';
import * as userStore from '@cartwhl/common/stores/userStore';

/* Needs to be loaded before the other stores that depend on it */
import * as webSocketStore from 'stores/webSocketStore';

import * as animationGenerationStore from './animationGenerationStore';
import * as animationPlayerStore from './animationPlayerStoreFactory';
import * as browseMotionStore from './browseMotionStore';
import * as browsePoseStore from './browsePoseStore';
import * as characterPickerStore from './characterPickerStore';
import * as historyStore from './historyStore';
import * as posingStore from './posingStore';
import * as projectStore from './projectStore';
import * as sceneSettingsStore from './sceneSettingsStore';
import * as uiStore from './uiStore';

authStore.init();

navigationStore.init({
  pages: [
    'embed',
    'home',
    'ui',
    'pose/:projectID',
    'projects',
    'motion/:projectID',
  ],
  defaultRoute: '',
});

animationGenerationStore.init();

// Exporting stores for easier access within the studio app
export {
  authStore,
  animationGenerationStore,
  animationPlayerStore,
  browseMotionStore,
  characterPickerStore,
  historyStore,
  navigationStore,
  noticesStore,
  userStore,
  posingStore,
  productStore,
  projectStore,
  sceneSettingsStore,
  uiStore,
  webSocketStore,
  browsePoseStore,
};
